import { Separator } from "reka-ui";
import { defineComponent } from "vue";
import { cn } from "@/utils/cn";
import { p } from "@/utils/props-builder";

export default defineComponent({
  name: "Separator",
  props: {
    orientation: p.string<"vertical" | "horizontal">("horizontal"),
  },
  setup(props, { attrs }) {
    return () => (
      <Separator
        orientation={props.orientation}
        class={cn(
          "shrink-0 bg-border",
          props.orientation === "vertical" ? "h-auto w-px" : "h-px w-full",
          attrs.class ?? ""
        )}
      />
    );
  },
});
